import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/api';
import { Button } from './ui/button';
import { User, SignOut, Wallet } from '@phosphor-icons/react';
import NotificationsBell from './NotificationsBell';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <nav className="glass-morphism sticky top-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img src="/vivalink-logo-transparent.png" alt="VivaLink Italia - Assistenza domiciliare e medica" className="h-16 md:h-20 w-auto" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/request"
              className="text-foreground hover:text-primary transition-colors duration-200"
              data-testid="nav-request-link"
            >
              Richiedi Assistenza
            </Link>
            <Link
              to="/come-funziona"
              className="text-foreground hover:text-primary transition-colors duration-200"
              data-testid="nav-hiw-link"
            >
              Come Funziona
            </Link>
            <Link
              to="/prestazioni"
              className="text-foreground hover:text-primary transition-colors duration-200"
              data-testid="nav-services-link"
            >
              Prestazioni
            </Link>
            <Link
              to="/search"
              className="text-foreground hover:text-primary transition-colors duration-200"
              data-testid="nav-search-link"
            >
              Sfoglia Professionisti
            </Link>
            <Link
              to="/premium"
              className="text-foreground hover:text-primary transition-colors duration-200 flex items-center gap-1"
              data-testid="nav-premium-link"
            >
              Premium
              <span className="text-xs bg-accent text-white px-2 py-0.5 rounded-full">PRO</span>
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                {user?.role === 'admin' && (
                  <Link to="/admin" data-testid="nav-admin-link">
                    <Button variant="outline" size="sm" className="rounded-full">
                      Admin
                    </Button>
                  </Link>
                )}
                <NotificationsBell />
                <Link to={
                  user?.role === 'admin' ? '/admin' :
                  user?.role === 'professional' ? '/professional-dashboard' : '/dashboard'
                }>
                  <Button variant="ghost" size="icon" data-testid="dashboard-btn">
                    <User size={20} />
                  </Button>
                </Link>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={logout}
                  data-testid="logout-btn"
                >
                  <SignOut size={20} />
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost" data-testid="login-btn">Accedi</Button>
                </Link>
                <Link to="/register">
                  <Button data-testid="register-btn">Registrati</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;